module.exports = "<p>\r\n  audio-help works!\r\n</p>\r\n"